import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {fetchDataIfReady, setAlert} from '../modules/fetch.action.js'
import {handleAutoResize, handleChange, areFieldsNotEmpty, areFieldsValid, sanitizePayload} from '../modules/functions.js'
import ModalWrapper from './Modal_Wrapper.js'
import Labels from './Labels.js'
import Metadata from './Metadata.js'
import icon_trash from '../images/icon-trash.svg';

const e = React.createElement;


function ModalFormBuilder(props) {
  React.Component.constructor.call(this);

  var new_state = {body_param_used:false};
  for(var i = 0; i < props.fields.length; i++) {
    var f = props.fields[i];
    new_state[f.dbcol] = "";
  }
  this.state = new_state;

  for(var i = 0; i < props.fields.length; i++) {
    if(props.fields[i].type === "textarea") {
      this["fieldRef"+i] = React.createRef();
    }
  }
}
ModalFormBuilder.prototype = Object.create(React.Component.prototype);

ModalFormBuilder.prototype.componentWillReceiveProps = function(nextProps) {
  if(nextProps.shouldShow && nextProps.update_data) {
    var newState = {};
    for(var i = 0; i < nextProps.fields.length; i++) {
      var f = nextProps.fields[i];
      if(this.state[f.dbcol] !== nextProps.update_data[f.dbcol]) newState[f.dbcol] = nextProps.update_data[f.dbcol];
      if(f.type === "textarea") newState[f.dbcol+"_height"] = "";
      if((f.type === "labels" || f.type === "metadata") && this.state[f.dbcol] !== nextProps.update_data[f.dbcol]) newState[f.dbcol+"_initial"] = newState[f.dbcol] = nextProps.update_data[f.dbcol];
      if((f.type === "labels" || f.type === "metadata") && nextProps.update_data[f.dbcol] === null) newState[f.dbcol+"_initial"] = newState[f.dbcol] = "";
      if(f.data_type === "datetime" && newState[f.dbcol] !== "") {
        var d = new Date(newState[f.dbcol]);
        newState[f.dbcol] = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate()+" "+d.getHours()+":"+d.getMinutes();
      }
    }
    this.setState(newState);
  } else if(nextProps.shouldShow && nextProps.content) {
    var newState = {};
    for(var i = 0; i < nextProps.fields.length; i++) {
      var f = nextProps.fields[i];
      if(nextProps.content[f.dbcol] && this.state[f.dbcol] !== nextProps.content[f.dbcol]) newState[f.dbcol] = nextProps.content[f.dbcol];
    }
    this.setState(newState);
  }
}

ModalFormBuilder.prototype.componentDidUpdate = function() {
  for(var i = 0; i < this.props.fields.length; i++) {
    if(this.props.fields[i].type === "textarea" && this["fieldRef"+i].current) {
      handleAutoResize(this, this["fieldRef"+i].current, this.props.fields[i].dbcol);
    }
  }
}

ModalFormBuilder.prototype.render = function() {
  if(this.props.shouldShow) {
    if(this.props.body_param === undefined || this.props.body_param === "" || this.state.body_param_used) {
      var form_fields = [];
      for(var i = 0; i < this.props.fields.length; i++) {
        var f = this.props.fields[i];
        if(f.type === "textarea") {
          form_fields[i] = e('div', {key:i}, e('textarea', {
            rows:f.rows ? f.rows : 1,
            placeholder:f.placeholder,
            value:this.state[f.dbcol],
            onChange:handleChange.bind(null, this, f.dbcol),
            maxLength:f.maxLength,
            autoFocus:i === 0 ? true : false,
            ref:this["fieldRef"+i],
            style:{resize:"none", height:this.state[f.dbcol+"_height"]},
            onKeyDown:!f.rows ? function(e) {e.key === "Enter" && this.handleCreate(e)}.bind(this) : null
          }));
        } else if(f.type === "date") {
          form_fields[i] = e('div', {key:i}, e('input', {
            type:"date",
            placeholder:f.placeholder,
            value:this.state[f.dbcol],
            onChange:handleChange.bind(null, this, f.dbcol),
            maxLength:"10",
          }));
        } else if(f.type === "img") {
          if(this.state[f.dbcol] !== "" && this.state[f.dbcol] !== undefined) {
            form_fields[i] = e('div', {key:i, style:{textAlign:"center", width:"100%", marginTop:"4px"}}, e('img', {src:this.state[f.dbcol], style:{maxWidth:"100%"}, alt:this.state[f.dbcol]}));
          } else if(this.props.update_data && this.props.update_data[f.attr] !== "" && this.props.update_data[f.attr] !== undefined) {
            form_fields[i] = e('div', {key:i, style:{textAlign:"center", width:"100%", marginTop:"4px"}}, e('img', {src:this.props.update_data[f.attr], style:{maxWidth:"100%"}, alt:this.props.update_data[f.attr_alt]}));
          }
        } else if(f.type === "select") {
          var select_fields = [];
          for(var so_i = 0; so_i < f.options.length; so_i++) {
            var o = f.options[so_i];
            select_fields[so_i] = e('option', {key:"so"+so_i, value:o.value}, o.label);
          }
          form_fields[i] = e('select', {key:i, name:f.dbcol, onChange:handleChange.bind(null, this, f.dbcol), value:this.state[f.dbcol]}, select_fields);
        } else if(f.type === "labels") {
          form_fields[i] = e('div', {key:i, style:{marginTop:"14px"}}, e(Labels, {label_list:this.props.label_list, item_labels:this.state[f.dbcol], item_labels_sn:f.dbcol, updateLabels:handleChange.bind(null, this)}));
        } else if(f.type === "metadata") {
          form_fields[i] = e('div', {key:i, style:{marginTop:"14px"}}, e(Metadata, {metadata_list:this.props.metadata_list, item_metadata:this.state[f.dbcol], item_metadata_sn:f.dbcol, updateMetadata:handleChange.bind(null, this)}));
        }
      }

      if(this.props.lettercounter) {
        var lc_field = this.props.fields[this.props.lettercounter];
        form_fields[i] = e('div', {key:"lettercounter", style:{textAlign:"right", fontSize:"70%", opacity:".4"}}, this.state[lc_field.dbcol].length+" / "+lc_field.maxLength);
      }

      form_fields[i+1] = e('div', {key:"submit"}, e('input', {type:"submit", value:!this.props.update_data ? "add" : "update", disabled:this.props.is_fetching}));

      form_fields[i+2] = e('i', {key:"hotkey", id:"modal-form-hook"});

      var delete_btn = "";
      if(this.props.api_endpoint_delete) {
        // todo: i18n
        delete_btn = e('div', {key:"delete", style:{textAlign:"right"}}, [e('button', {key:"prompt-btn", className:"btn btn-c", onClick:function() {this.handleDeletePrompt()}.bind(this)}, e('img', {src:icon_trash, alt:"Delete"})), e('div', {key:"prompt-div", id:"delete-prompt", style:{display:"none", marginTop:"7px"}}, [e('span', {key:"prompt-span", style:{marginRight:"14px"}}, "Are you sure?"), e('button', {key:"delete-btn", className:"btn", onClick:function() {this.handleDelete()}.bind(this)}, "yes")])]);
      }

      return e(ModalWrapper, {switchState:this.props.close}, [e('form', {key:"form", onSubmit:function(e) {this.handleCreate(e)}.bind(this)}, form_fields), delete_btn]);
    } else {
      var picker_style = {marginBottom:"12px", padding:"10px", background: "#0000000f"};
      var picker_fields = [];
      for(var i = 0; i < this.props.fields.length; i++) {
        var f = this.props.fields[i];
        if(f.type === "textarea") {
          picker_fields[i] = e('div', {key:"p"+i, onClick:this.handlePicker.bind(this, f.dbcol, this.props.body_param), style:picker_style}, f.dbcol);
        }
      }
      // todo: i18n
      picker_fields[i] = e('div', {key:"shared"}, "Shared: "+this.props.body_param);

      return e(ModalWrapper, {switchState:this.props.close}, e('div', null, picker_fields));
    }
  } else {
    return null;
  }
}

ModalFormBuilder.prototype.handlePicker = function(state_name, value) {
  var newState = {};
  newState[state_name] = value;
  newState["body_param_used"] = true;
  this.setState(newState);
}

ModalFormBuilder.prototype.handleCreate = function(e) {
  e.preventDefault();
  var payload = {}, state_reset = {};
  for(var i = 0; i < this.props.fields.length; i++) {
    var f = this.props.fields[i];
    if(f.type !== "img" && f.type !== "labels" && f.type !== "metadata") {
      payload[f.dbcol] = this.state[f.dbcol] ? this.state[f.dbcol] : "";
      state_reset[f.dbcol] = "";
      if(f.type === "textarea") state_reset[f.dbcol+"_height"] = "";
      if(f.type === "select" && payload[f.dbcol] === "") payload[f.dbcol] = f.defaultValue;
    } else if(f.type === "labels") {
      if(this.props.update_data) {
        var init_splitted = this.state[f.dbcol+"_initial"].split(";;");
        var new_splitted = this.state[f.dbcol].split(";;");
        var init_without_date = init_splitted.map(function(label) {
          return label.split(",")[0];
        });
        var new_without_date = new_splitted.map(function(label) {
          return label.split(",")[0];
        });
        var nw_labels = new_without_date.filter(function(_label_id) {
          return init_without_date.indexOf(_label_id) === -1;
        }).join(';;');
        var rm_labels = init_without_date.filter(function(_label_id) {
          return new_without_date.indexOf(_label_id) === -1;
        }).join(';;');
        payload["nw_"+f.dbcol] = nw_labels;
        payload["rm_"+f.dbcol] = rm_labels;
      } else {
        payload[f.dbcol] = this.state[f.dbcol] ? this.state[f.dbcol] : "";
      }
      //state_reset[f.dbcol+"_initial"] = "";
      //state_reset[f.dbcol] = "";
    } else if(f.type === "metadata") {
      if(this.props.update_data) {
        var init_splitted = this.state[f.dbcol+"_initial"].split(";;");
        var new_splitted = this.state[f.dbcol].split(";;");
        var nw_labels = new_splitted.filter(function(_metadata_json) {
          return init_splitted.indexOf(_metadata_json) === -1;
        }).join(';;');
        var rm_labels = init_splitted.filter(function(_metadata_json) {
          return new_splitted.indexOf(_metadata_json) === -1;
        }).join(';;');
        payload["nw_"+f.dbcol] = nw_labels;
        payload["rm_"+f.dbcol] = rm_labels;
      } else {
        payload[f.dbcol] = this.state[f.dbcol] ? this.state[f.dbcol] : "";
      }
      state_reset[f.dbcol+"_initial"] = "";
      state_reset[f.dbcol] = "";
    }
  }

  if(!this.props.required_fields || (this.props.required_fields && areFieldsNotEmpty(this.props.required_fields, payload, this.props.setAlert))) {
    if(!this.props.validate_fields || (this.props.validate_fields && areFieldsValid(this.props.validate_fields, payload, this.props.setAlert))) {
      if(this.props.validation_tudu && payload["status"] === "3") {
        var page_cards = this.props.apiData["doing_list"];
        if(page_cards !== undefined && page_cards.data && page_cards.data[0] && page_cards.data[0] !== null) {
          this.props.setAlert("Ongeldig: mag maar één item tegelijk op \"doing\"."); // todo: i18n
          return;
        }
      }

      if(this.props.is_fetching === false || this.props.is_fetching === null) {
        if(this.props.validate_fields) {
          payload = sanitizePayload(this.props.validate_fields, payload);
        }
        var success_alert = (typeof this.props.success_alert !== 'undefined') ? success_alert : true;
        this.props.fetchDataIfReady(this.props.config.api_token, this.props.api_block, this.props.api_method, this.props.config.api_url+this.props.api_endpoint+"?t="+this.props.session_token, JSON.stringify(payload), null, true, false, success_alert, false, false, null, this.props.api_block_clear);
        this.setState(state_reset);
        this.props.close();
      }
    }
  }
}

ModalFormBuilder.prototype.handleDeletePrompt = function() {
  var prompt = document.getElementById("delete-prompt");
  prompt.style.display = "block";
}

ModalFormBuilder.prototype.handleDelete = function() {
  var success_alert = (typeof this.props.success_alert !== 'undefined') ? success_alert : true;
  this.props.fetchDataIfReady(this.props.config.api_token, "bin", "DELETE", this.props.config.api_url+this.props.api_endpoint_delete+"?t="+this.props.session_token, JSON.stringify({id:this.state.id}), null, true, false, success_alert, false, false, null, this.props.api_block_clear);
  this.props.close();
}


function mapStateToProps(state, ownProps) {
  var session_token = null, is_fetching = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData[ownProps.api_block] !== undefined && state.apiData[ownProps.api_block].isFetching !== undefined) {
    is_fetching = state.apiData[ownProps.api_block].isFetching;
  }

  return {
    session_token: session_token,
    is_fetching: is_fetching,
    apiData: state.apiData, // only needed for tudu's validation.
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalFormBuilder)



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/ModalFormBuilder.js
// module id = 99
// module chunks = 0